import { Injectable } from '@angular/core';

import { ApiService }       from '../../app-lite/api/api.service';
import { SessionModel }     from '../../app-lite/sessions/models/session';
import { SessionService }   from '../../app-lite/sessions/session.service';
import { UserAccountModel } from '../users/models/user.account';

@Injectable()
export class SignUpService {
  constructor (
    private apiService    : ApiService,
    private sessionService: SessionService
  ) {}

  signUp ( account : UserAccountModel ) : ng.IPromise<SessionModel> {
    return this.apiService.post('/customer_portal_users/create_password', {
      password: account.password,
      token   : account.token
    })
    .then(( session : SessionModel ) => this.sessionService.setSession(session));
  }
}
